// Presentation aliases only: registry IDs and pinned releases stay unchanged.
export const MODEL_DISPLAY = {
  'lyncia-counselor-r17-c4-step249': { name: 'LynciaCounselor-Omni-R1', version: 'v1.0' },
  'lyncia-counselor-omni-r16-c5-step99': { name: 'LynciaCounselor-Omni-R1', version: 'r16 C5 step99' },
  'lyncia-counselor-omni-r1-inline': { name: 'LynciaCounselor-Omni-R1', version: 'v0.5' },
  'lyncia-counselor-omni-r1': { name: 'LynciaCounselor-Omni-R1', version: 'v0.5' },
};
export function visibleModels(models) {
  // Keep aliases for historical labels, but offer only the current versions.
  const available = models.filter(model => model.id !== 'lyncia-counselor-omni-r16-c5-step99');
  const legacy = available.find(model => model.id === 'lyncia-counselor-omni-r1-inline')
    || available.find(model => model.id === 'lyncia-counselor-omni-r1');
  const curated = [available.find(model => model.id === 'lyncia-counselor-r17-c4-step249'), legacy].filter(Boolean);
  return curated.length ? curated : available;
}
export function defaultModel(models, deploymentDefault) {
  const visible = visibleModels(models);
  return visible.find(model => model.id === 'lyncia-counselor-r17-c4-step249')
    || visible.find(model => model.id === deploymentDefault) || visible[0];
}
